





















































































import Vue from 'vue';
import Page from '../components/Page.vue';
import Card from '../components/common/Card.vue';
import SuccessIcon from '../components/common/icons/SuccessIcon.vue';
import PrimaryButton from '../components/common/buttons/PrimaryButton.vue';
import SignUpNotificationPopover from '../components/common/SignUpNotificationPopover.vue';
import RequestNumberConfirmationBox from '@/components/common/RequestNumberConfirmationBox.vue';
import { createNamespacedHelpers } from 'vuex';
import { mapState as mapRootState } from 'vuex';
const { mapState } = createNamespacedHelpers('confirm');
const mapCustomLabelsState = createNamespacedHelpers('customLabels').mapState;
export default Vue.extend({
    components: { SignUpNotificationPopover, PrimaryButton, SuccessIcon, Card, Page, RequestNumberConfirmationBox },
    computed: {
        ...mapCustomLabelsState([
            'portalTitle',
            'instanceTitle',
            'grievanceConfirmSuccessText',
            'grievanceConfirmInfoText',
            'grievanceConfirmSubmitPasswordSuccessText',
            'grievanceConfirmFollowUp',
        ]),
        ...mapState(['passwordCreated', 'refNo']),
        ...mapRootState(['portalBranding']),
    },
    created() {
        const portalTitle = this.portalTitle;
        const instanceTitle = this.instanceTitle;
        document.title = `${instanceTitle} | ${this.$t('htmlTitle', { portalTitle }) as string}`;
    },
});
